import { observable } from 'mobx';

import PAGES from '../definitions/Pages';


function createConfirmationPageVM(context) {
    if (!context) {
        throw new RangeError('Context provided to view model is empty', 'createConfirmationPageVM.js');
    }

    const state = observable({
        context,

        name: PAGES.CONFIRMATION.id,

        get isActive() {
            return context.viewStore?.activePageName === state.name;
        },

        get values() {
            return {
                get name() {
                    return state.name;
                },

                get formType() {
                    return context.formType;
                },
                get provider() {
                    return context.provider;
                },

                // Coverage information
                get insuranceType() {
                    return context.insuranceType;
                },
                get coverageAmount() {
                    return context.journey?.coverageAmount;
                },
                get disabilityCoverageAmount() {
                    return context.journey?.disabilityCoverageAmount;
                },

                // Applicant information
                get firstName() {
                    return context.journey?.applicant?.firstName;
                },
                get fullName() {
                    const firstName = context.journey?.applicant?.firstName;
                    const lastName = context.journey?.applicant?.lastName;

                    return firstName && lastName
                        ? `${firstName} ${lastName}`
                        : '';
                },
                get dateOfBirth() {
                    return context.journey?.applicant?.dob;
                },
                get hasConsumedTobacco() {
                    return context.journey?.applicant?.hasConsumedTobacco;
                },
                get phone() {
                    return context.journey?.applicant?.phone;
                },
                get email() {
                    return context.journey?.applicant?.email;
                },

                // Joint applicant information
                get jointApplicantFullName() {
                    const firstName = context.journey?.jointApplicant?.firstName;
                    const lastName = context.journey?.jointApplicant?.lastName;

                    return firstName && lastName
                        ? `${firstName} ${lastName}`
                        : '';
                },
                get jointApplicantDateOfBirth() {
                    return context.journey?.jointApplicant?.dob;
                },
                get hasJointApplicantConsumedTobacco() {
                    return context.journey?.jointApplicant?.hasConsumedTobacco;
                },

                // Group information
                get companyName() {
                    return context.journey?.companyName;
                },
                get businessAddress() {
                    return context.journey?.businessAddress;
                },
                get numberOfEmployees() {
                    return context.journey?.numberOfEmployees;
                },
            };
        },
    });

    return state;
}

export default createConfirmationPageVM;